import React, { useState, useEffect } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { Link as LinkScroll } from "react-scroll";
import showdown from 'showdown';
import Truncate from 'react-truncate';
import DivisorLine from './DivisorLine';
import { Link } from 'gatsby';
const converter = new showdown.Converter()

const Item = ({
    name,
    desc
}) => {
    return (
        <div
            className="px-3">
            <div
                style={{ height: "200px" }}
                className="mb-2">
                <div className="text-center font-weight-bold mb-3">
                    {name}
                </div>
                <div className="text-muted text-justify" style={{ height: "170px" }}>
                    {/* <Truncate lines={7} ellipsis={<span>...</span>}> */}
                    <div
                        className="text-muted text-justify"
                        dangerouslySetInnerHTML={{ __html: converter.makeHtml(desc) }} />
                    {/* </Truncate> */}
                </div>
            </div>
        </div>
    )
}

const LandingSection2 = ({
    section2
}) => {
    const {
        title,
        desc,
        btnTitle,
        videoIframe
    } = section2;

    return (
        <section
            className="container-fluid py-5">
            <div className="container">
                <div className="row">
                    <div className="col-md-6 px-3 mb-4 mb-md-0 d-flex flex-column justify-content-center">
                        <div
                            style={{ opacity: ".5" }}
                            className="text-center font-weight-bold text-muted mb-3 font2">
                            {title}
                        </div>
                        <div
                            className="text-justify"
                            dangerouslySetInnerHTML={{ __html: converter.makeHtml(desc) }} />
                        <Link
                            to="contacts"
                            style={{ width: "200px" }}
                            className="btn btn-primary btn-1 py-3">
                            {btnTitle}
                        </Link>
                    </div>
                    {
                        videoIframe && (
                            <div className="col-md-6 px-3 d-flex align-items-center justify-content-center">
                                <div
                                    className="w-100"
                                    dangerouslySetInnerHTML={{ __html: converter.makeHtml(videoIframe) }} />
                            </div>
                        )
                    }
                </div>
                <DivisorLine
                    style={{
                        margin: "3rem 0 3rem 0",
                        height: "30px"
                    }}
                />

                {/* displayed in desktop */}
                <div className="d-none d-md-block">
                    <div className="row">
                        {
                            section2.items.map((item, index) => (
                                <div
                                    key={`propy${index}`}
                                    className="col-md-6 col-lg-4 mb-md-3 mb-lg-0">
                                    <Item {...item} />
                                </div>
                            ))
                        }
                    </div>
                </div>

                {/* displayed in mobile */}
                <div className="d-block d-md-none">
                    <Carousel showStatus={false} showThumbs={false} emulateTouch>
                        {
                            section2.items.map((item, index) => (
                                <div
                                    key={`propx${index}`}
                                    className="mb-5">
                                    <Item
                                        {...item}
                                    />
                                </div>
                            ))
                        }
                    </Carousel>
                </div>
            </div>
        </section>
    )
}

export default LandingSection2;